/* eslint-disable no-param-reassign */

export default {
  toggleFilter(state, flag) {
    state.isOpen = flag;
  },
  setIsActiveFilter(state, flag) {
    state.isActive = flag;
  },
  isNotFound(state, flag) {
    state.isNotFound = flag;
  },
  setIsDisable(state, flag) {
    state.isDisable = flag;
  },
  setCurrentFilter(state, currentFilter) {
    state.currentFilter = currentFilter;
  },
  setExportSessionFilterSnapshot(state, snapshot) {
    state.exportSessionFilterSnapshot = snapshot;
  },
  clearExportSessionFilterSnapshot(state) {
    state.exportSessionFilterSnapshot = null;
  },
  setDefaultEmptyFilter(state, currentFilter) {
    state.currentFilter = currentFilter;
  },
  setSavedFilters(state, filters) {
    state.savedFilters = filters;
  },
  setActiveFilters(state, activeFilters) {
    state.activeFilters = activeFilters;
  },
  updateCurrentFilter(state, payload) {
    const updated = {
      ...state.currentFilter,
      ...payload,
    };

    state.currentFilter = updated;
  },
  addSavedFilter(state, filter) {
    const savedFilters = state.savedFilters;

    if (!savedFilters[filter.type]) {
      savedFilters[filter.type] = [];
    }
    savedFilters[filter.type].push(filter);
  },
  removeSavedFilterByIdAndType(state, payload) {
    let filters = state.savedFilters[payload.type];

    filters = filters.filter(filter => filter.id !== payload.filterId);
    state.savedFilters[payload.type] = filters;
  },
  updateFilterName(state, payload) {
    const savedFilters = state.savedFilters;
    const filters = savedFilters[payload.type];
    const filter = filters.find(item => item.id === payload.id);

    if (filter) {
      const index = filters.indexOf(filter);

      const updated = {
        ...filter,
        name: payload.name,
      };

      filters.splice(index, 1, updated);
      savedFilters[payload.type] = filters;
    }
  },
  // updateAdvancedSettingsByFilterType(state, payload) {
  //   const settings = state.advancedSettings[payload.type];

  //   if (settings) {
  //     const updatedFilterSettings = {
  //       ...settings,
  //       ...payload.settings,
  //     };

  //     const updatedSettings = {
  //       ...state.advancedSettings,
  //       [payload.type]: updatedFilterSettings,
  //     };

  //     state.advancedSettings = updatedSettings;
  //   }
  // },
  updateAdvancedSettingsByFilterType(state, payload) {
    const prevSettings = state.advancedSettings[payload.type] || {};

    state.advancedSettings = {
      ...state.advancedSettings,
      [payload.type]: {
        ...prevSettings,
        ...payload.settings,
      },
    };
  }
};
